
<video 
  #videoRef
  class="home__video-loader"
  src="/assets/fitur-2026/videos/video-loader.mp4" 
  width="100%"
  height="100%"
  autoplay 
  muted 
  playsinline
></video>